import React from 'react'
import { Marker } from '@react-google-maps/api'

// Start/End markers for a drawn trace polyline — green "S" where the trace
// begins, red "E" where it ends. Shared by every map (dashboard, main map,
// vehicle details, route history) so all of them mark endpoints the same way.
const TraceEndpoints = ({ path }) => {
    if (!window.google?.maps || !path?.length || path.length < 2) return null
    const markerIcon = (fillColor) => ({
        path: window.google.maps.SymbolPath.CIRCLE,
        scale: 8,
        fillColor,
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 2,
    })
    const markerLabel = (text) => ({
        text,
        color: '#ffffff',
        fontSize: '10px',
        fontWeight: '700',
    })
    return (
        <>
            <Marker
                position={path[0]}
                title="Start"
                icon={markerIcon('#34a853')}
                label={markerLabel('S')}
                zIndex={1000}
            />
            <Marker
                position={path[path.length - 1]}
                title="End"
                icon={markerIcon('#d93025')}
                label={markerLabel('E')}
                zIndex={1000}
            />
        </>
    )
}

export default TraceEndpoints
